import { memo } from 'react'
import { Handle, Position } from 'reactflow'

/**
 * React Flow 用カスタムノード：原子
 * 元素記号を丸いバッジで表示する
 */
function AtomNode({ data, selected }) {
  const color = data.color || '#94A3B8'
  // 白系（水素）は文字を暗くして視認性を確保
  const isLight = ['#E6E6E6', '#FFFFFF'].includes((color || '').toUpperCase())
  const textColor = isLight ? '#1a1f35' : '#ffffff'

  return (
    <div className="group relative">
      <Handle
        type="target"
        position={Position.Left}
        className="!w-3 !h-3 !bg-white/40 !border-white/60"
      />
      <div
        className="flex items-center justify-center rounded-full shadow-xl select-none transition-all"
        style={{
          width: 54,
          height: 54,
          background: `radial-gradient(circle at 35% 30%, ${color}, ${color}CC)`,
          border: `3px solid ${selected ? '#34D399' : 'rgba(255,255,255,0.35)'}`,
          boxShadow: selected
            ? `0 0 18px ${color}AA`
            : '0 4px 12px rgba(0,0,0,0.4)',
          color: textColor,
          fontSize: 20,
          fontWeight: 900,
          fontFamily: "'Inter', sans-serif",
        }}
      >
        {data.element}
      </div>
      <Handle
        type="source"
        position={Position.Right}
        className="!w-3 !h-3 !bg-white/40 !border-white/60"
      />

      {/* Remove button */}
      {data.onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation()
            data.onRemove(data.nodeId)
          }}
          className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-red-500/80 text-white text-xs flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-500"
        >
          ×
        </button>
      )}
    </div>
  )
}

export default memo(AtomNode)
